import { render, staticRenderFns } from "./BBS901P02.vue?vue&type=template&id=53225f28&"
import script from "./BBS901P02.vue?vue&type=script&lang=js&"
export * from "./BBS901P02.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports